<template>
  <v-container>
  </v-container>
</template>

<script>
export default {
  name: "ViewServiceAreas",
  props: {
    serviceArea: {
      postalCode: String,
      name: String,
      services: Array
    }
  }
}
</script>

<style scoped>

</style>